module.exports = __webpack_public_path__ + "static/media/mobile-04.fc631bcb.png";